import React, { useState } from "react";
import MyHeader from "./Header.module.css";
import HeaderAvatar from "../Avatar/HeaderAvatar";
import { useSelector, useDispatch } from "react-redux";
import { closeShareModal, closeVersionModal } from '../../app/EditorSlice';
import DocumentMembers from "../Members/members";
import HeaderMembers from "../Members/HeaderMembers";
import Modes from '../Modes';
import TemplateActiveToggle from '../TemplateToggle/TemplateActiveToggle';
import AppLauncher from '../AppLauncher';
import OfflineToggle from '../OfflineToggle';
import VersionModalContent from "../DocumnetVersion/VersionsModal/versionModalContent.js";
import VersionsModal from "../DocumnetVersion/VersionsModal/versionsModal.js";
import { ShareModalContent } from "../ShareModal/ShareModalContent/ShareModalContent";
import { ShareModal } from "../ShareModal/ShareModal";
import { Modal, Drawer } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import TemplateThumbnail from '../TemplateThumbnail/templateThumbnail';
import HeaderMenu from './HeaderMenu';

const RightHeader = ({ isMobile, leftRef, leftActionsRef }) => {
    const dispatch = useDispatch();
    const shareModalOpen = useSelector((state) => state.editor.modals.share);
    const versionDrawerOpen = useSelector((state) => state.editor.modals.version);
    const documentInformation = useSelector((state) => state.editor.documentInformation);
    const userInformation = useSelector((state) => state.editor.userInformation);
    const isReadOnly = useSelector((state) => state.editor.isReadOnly);
    const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
    const [showAppLauncher, setShowAppLauncher] = useState(false);
    const [membersDrawerOpen, setMembersDrawerOpen] = useState(false);
    const [sharePrivacy, setSharePrivacy] = useState(0);
    const [shareView, setShareView] = useState("access");
    // Both closers reset the dialog so the next open starts on General access.
    const closeShare = () => {
        dispatch(closeShareModal());
        setSharePrivacy(0);
        setShareView("access");
    };


    return (
        <>
            {/* Every control sits on one 30px rhythm (see .actions in the CSS).
                Share is the one primary; hairlines set off the offline pill and
                the account cluster, as in milegrid. */}
            <div className={MyHeader.actions}>
                {!isTemplateDocument && !isReadOnly && <OfflineToggle />}
                {!isTemplateDocument && !isReadOnly && <span className={MyHeader.actionsDivider} aria-hidden="true" />}
                {!isTemplateDocument && <HeaderMembers />}
                {!isReadOnly && !isTemplateDocument && <VersionsModal leftRef={leftActionsRef} />}
                {!isReadOnly && documentInformation.createBy == userInformation.userId && !isTemplateDocument && <ShareModal />}
                {isTemplateDocument && <TemplateActiveToggle />}
                {isTemplateDocument && <TemplateThumbnail />}
                <span className={MyHeader.actionsDivider} aria-hidden="true" />
                <AppLauncher open={showAppLauncher} onOpenChange={setShowAppLauncher} />
                <Modes isMobile={isMobile} />
                <HeaderAvatar />
                {/* Small screens (see the CSS): the controls above give way to a
                    hamburger carrying the same actions, then the avatar. */}
                <div className={MyHeader.compact}>
                    <HeaderMenu onOpenAppLauncher={() => setShowAppLauncher(true)} />
                    <HeaderAvatar />
                </div>
            </div>
            <Modal
                title={(
                    <div className="share-modal-heading">
                        <span className="share-modal-heading__badge">
                            <ShareAltOutlined />
                        </span>
                        <span className="share-modal-heading__text">
                            <span className="share-modal-heading__title">Share</span>
                            <span className="share-modal-heading__doc">Invite people or share a link</span>
                        </span>
                    </div>
                )}
                visible={shareModalOpen}
                onOk={closeShare}
                onCancel={closeShare}
                footer={false}
                width={460}
                centered
                destroyOnClose
                className="share-doc-modal"
            >
                <ShareModalContent
                    setIsModalVisible={closeShare}
                    privacy={sharePrivacy}
                    setPrivacy={setSharePrivacy}
                    view={shareView}
                    setView={setShareView}
                />
            </Modal>

            <Drawer title="Version history" placement="right" onClose={() => dispatch(closeVersionModal())} visible={versionDrawerOpen}>
                <div>
                    <VersionModalContent open={versionDrawerOpen} setOpen={() => dispatch(closeVersionModal())} setShowVersionButtons={() => { }} />
                </div>
            </Drawer>

            <Drawer title="Members" placement="right" onClose={() => setMembersDrawerOpen(false)} visible={membersDrawerOpen}>
                <div>
                    <DocumentMembers />
                </div>
            </Drawer>
        </>
    );
};

export default RightHeader;